import { formatTime } from '@/util/helpers/time-helpers';

class DashboardRef {
  constructor(
    id,
    refreshId,
    name,
    refreshFrequency,
    time,
    isPublic,
    guests,
    isEmbedded,
  ) {
    this._id = id; // uuid
    this._refreshId = refreshId;
    this._name = name;
    this._refreshFrequency = refreshFrequency;
    this._time = time;
    this._isPublic = isPublic;
    this.guests = guests;
    this.isEmbedded = isEmbedded;
  }

  static build(serverObj) {
    const time = formatTime(serverObj._time);
    return new DashboardRef(
      serverObj._id,
      serverObj._refreshId,
      serverObj._name,
      serverObj._refreshFrequency,
      time,
      serverObj._isPublic,
      serverObj._sharedUsers,
      serverObj.isEmbedded,
    );
  }

  static buildNew(serverObj) {
    const time = formatTime(serverObj.refreshTime);
    return new DashboardRef(
      serverObj.id,
      serverObj.lastRefreshId,
      serverObj.name,
      serverObj.refreshFrequency,
      time,
      serverObj.isPublic,
      serverObj.numberOfShares,
      serverObj.isEmbedded,
    );
  }

  id() {
    return this._id;
  }

  name() {
    return this._name;
  }

  guests() {
    return this.guests;
  }

  refreshId() {
    return this._refreshId;
  }

  refreshFrequency() {
    return this._refreshFrequency;
  }

  time() {
    return this._time;
  }

  isPublic() {
    return this._isPublic;
  }

  resetRefreshId() {
    // Not using build function because the time property is already built
    return new DashboardRef(
      this.id(),
      null,
      this.name(),
      this.refreshFrequency(),
      this.time(),
      this.isPublic(),
    );
  }
}

export default DashboardRef;
